import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

// Component
import ContactUs from './ContactUs';

import gtag from 'ga-gtag';

const Contact = () => {
  
  return (
      <div className='contact-section'>
        <ContactUs />
      </div>
  );
}

export default Contact;